export default "__VITE_ASSET__33bJotIE__"